<div
  class="alert-user alert-user--{{ erroType }} alert-user--{{ border_alert }}"
  [@animate]="{ value: '*', params: { delay: '400ms' } }">
  <mat-icon *ngIf="showIcon">{{ icon }}</mat-icon>
  <ng-container *ngIf="isTranslatable; else elseTemplate">
    {{ errorMessage | translate }}
  </ng-container>
  <ng-template #elseTemplate>
    {{ errorMessage }}
  </ng-template>
  <a *ngIf="urlRedirect" target="_blank" href="{{ urlRedirect }}" class="alert-link"
    >ADQUIRIR AHORA</a
  >
</div>
